/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["app-combobox clr-input-container.clr-form-control{margin-top:0}.highlighted[_ngcontent-%COMP%]{border:1px solid var(--clr-forms-focused-color);border-radius:2px}.select-option[_ngcontent-%COMP%]{margin-top:.4rem;padding:.1rem .3rem;cursor:pointer}.select-option[_ngcontent-%COMP%]:not(.highlighted){border:1px solid transparent}.clearOption[_ngcontent-%COMP%]{font-style:italic}.options-container[_ngcontent-%COMP%]{max-height:20rem;overflow-x:hidden;overflow-y:auto}"];
export { styles as styles };

